define(function(require) {
  // general
  const CommonReviewCode = require('civicsViews/assign_review/common/common');
  const CN = require('civicsUtils/constants');
  // templates
  const tpl = require('civicsViews/problems/templates/t_lov_problems.hbs');
  // views
  const ProblemsCompositeView = require('civicsViews/problems/v_cpv_problems');

  return Marionette.LayoutView.extend({
    initialize: function(options) {
      if (__DEV__) console.log('lov_problems -- initialize');
      this.config = options.config;
      this.collection = options.collection;
      this.currentSort = options.initialProblemsSort;
      this.applicationModel = options.applicationModel;
      this.showAllItems = false;
      this.expanded = {
        value: false
      };
    },
    template: tpl,
    regions: {
      tableViewRegion: '@ui.desktopView',
    },
    ui: {
      desktopView: '.activity-problems-table',
    },
    events: {
      'click @ui.btnFinishRecordingResults': 'recordResultsClicked', // same event called as btnRecordResults
      'click @ui.btnRecordResults': 'recordResultsClicked',
    },
    onRender: function() {
      if (__DEV__) console.log('lov_problems -- onRender');
    },
    onShow: function() {
      if (__DEV__) console.log('lov_problems -- onShow');

      var problemCollection = this.collection.sort(this.currentSort.field, this.currentSort.direction);
      // Logs Composite View
      this.problemsCompositeView = new ProblemsCompositeView({
        config: this.config,
        collection: problemCollection,
        currentSort: this.currentSort,
        showAllItems: this.showAllItems,
        expanded: this.expanded
      });
      this.tableViewRegion.show(this.problemsCompositeView);

      // Logs Composite Mobile View
      /*
      this.problemsCompositeViewMobile = new ProblemsCompositeViewMobile({
          config: this.config,
          collection: this.collection,
          showAllItems: this.showAllItems
      });
      this.tableViewMobileRegion.show(this.problemsCompositeViewMobile);
      */
      this.$el.rhythmThemeInit();
    },

    isDesktopViewVisible: function() {
      return this.ui.desktopView.css('display') != 'none';
    },
    recordResultsClicked: function() {
      App.sessionStorage.set('CIVICS', 'PREV_PAGE', document.URL.urlPath().toString()); //store url in session storage
    },
    templateHelpers: function() {
      var self = this;
      var helpers = {
        count: self.collection.length,
        showComments: function() {
          return !self.config.isPublic;
        },
        showRecordResultsButton: function() {
          return self.config.isProvider && this.isReviewOpen;
        },
        recordResultsTargetPage: function() {
          if (typeof self.config.recordResultsTargetPage == 'undefined') {
            return 'error_no_target_page_defined';
          }
          return self.config.recordResultsTargetPage.urlPath({
            type: CN.RECORD_TYPES()[self.config.fromServer.instrumentType.toLowerCase()],
            id: self.config.fromServer.reviewId,
            rev: 'y'
          });
        },
      };

      // Add the common helpers
      _.extend(helpers, CommonReviewCode.commonHelpers(this));
      return helpers;
    }
  });
});
